import React from 'react';
import Icon from '../../../components/AppIcon';

const SpeakerProfiles = ({ event }) => {
  // Mock speakers data - in a real app, this would come from the event data
  const speakers = [
    {
      id: 1,
      name: 'Dr. Sarah Chen',
      title: 'Director of Smart Cities Initiative',
      organization: 'Urban Innovation Lab',
      bio: 'Leading expert in IoT applications for urban infrastructure with over 15 years of experience.',
      image: null,
      credentials: ['PhD in Urban Planning', 'MIT Smart Cities Fellow']
    },
    {
      id: 2,
      name: 'Michael Rodriguez',
      title: 'Chief Technology Officer',
      organization: 'CityTech Solutions',
      bio: 'Pioneering sustainable technology solutions for metropolitan areas across North America.',
      image: null,
      credentials: ['Former Google X Team Lead', 'Author of "Digital Cities"']
    },
    {
      id: 3,
      name: event?.organizer?.full_name || 'Event Organizer',
      title: 'Event Host',
      organization: event?.organizer?.organization || 'Smart Cities Foundation',
      bio: 'Dedicated to fostering innovation and collaboration in urban development.',
      image: event?.organizer?.profile_image_url,
      credentials: ['Event Organizer', 'Industry Professional']
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center space-x-2">
        <Icon name="Users" size={20} />
        <span>Featured Speakers</span>
      </h3>

      <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-1">
        {speakers?.map((speaker) => (
          <div key={speaker?.id} className="flex items-start space-x-4 p-4 bg-muted/30 rounded-lg">
            <div className="flex-shrink-0">
              {speaker?.image ? (
                <img
                  src={speaker?.image}
                  alt={speaker?.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
              ) : (
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="User" size={24} className="text-primary" />
                </div>
              )}
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="font-medium text-foreground">{speaker?.name}</h4>
              <p className="text-sm text-primary font-medium">{speaker?.title}</p>
              <p className="text-sm text-muted-foreground mb-2">{speaker?.organization}</p>
              
              <p className="text-sm text-muted-foreground leading-relaxed mb-3">
                {speaker?.bio}
              </p>

              {speaker?.credentials && speaker?.credentials?.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {speaker?.credentials?.map((credential, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-primary/10 text-primary"
                    >
                      {credential}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} className="text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Interactive Q&A Session</p>
            <p>Participate in live discussions and ask questions directly to our expert speakers.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerProfiles;